export default __webpack_public_path__ + "static/media/sidebar-2.56583039.jpg";